// extracted by mini-css-extract-plugin
export default {"user_info":"UserInfo_user_info__kgLhQ"};